'use strict';

var modulecontrollers;

var ModuleControllers = class {
	
	constructor() {
		this.module = null;
		
		//this.Ethereum_core = require('../../../ethereum_core');
		this.Ethereum_core = require('@p2pmoney-org/ethereum_core');
		
		this.ethereum_core = this.Ethereum_core.getObject();
		
		this.global = this.ethereum_core.getGlobalObject();

		this.session = null;
	}
	
	getGlobalObject() {
		return this.global;
	}
	
	//
	// Session
	//

	getCurrentSessionObject() {
		if (this.session)
			return this.session;
		
		this.session = this.createBlankSessionObject();
		
		return this.session;
	}
	
	createBlankSessionObject() {
		var global = this.global;
		var commonmodule = global.getModuleObject('common');

		this.session = commonmodule.createBlankSessionObject();
		
		return this.session;
	}

	
	//
	// Storage-access
	//

	getArtifact(artifactname) {
		return this.ethereum_core.getArtifact(artifactname);
	}
	

	putArtifact(artifactpath, artifactcontent) {
		var global = this.global;
		var Ethereum_core = this.Ethereum_core;
		var ethereum_core = (Ethereum_core ? Ethereum_core.getObject() : null);

		if (ethereum_core)
		return ethereum_core.putArtifact(artifactpath, artifactcontent);
	}
	
	// stored on the local storage (either client or server side depending on session)
	async getLocalJsonLeaf(session, keys, bForceRefresh) {
		// obsolete naming
		var localstorage = session.getLocalStorageObject();
		
		const result = new Promise((resolve, reject) => { 
			localstorage.readLocalJson(keys, bForceRefresh, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}

	_getLocalJsonLeaf(session, keys, bForceRefresh, callback) {
		// OBSOLETE
		var localstorage = session.getLocalStorageObject();
		
		return localstorage.readLocalJson(keys, bForceRefresh, callback)
	}
	
	async readLocalJson(session, keys, bForceRefresh) {
		var localstorage = session.getLocalStorageObject();
		
		const result = new Promise((resolve, reject) => { 
			localstorage.readLocalJson(keys, bForceRefresh, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}
	
	async saveLocalJson(session, keys, json) {
		var localstorage = session.getLocalStorageObject();
		
		const result = new Promise((resolve, reject) => { 
			localstorage.saveLocalJson(keys, json, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}
	
	_saveLocalJson(session, keys, json, callback) {
		// OBSOLETE
		var localstorage = session.getLocalStorageObject();
		
		localstorage.saveLocalJson(keys, json, callback)
	}
	
	// stored on the client side
	async readClientSideJson(session, keys) {
		var clientAccess = session.getClientStorageAccessInstance();
		
		const result = new Promise((resolve, reject) => { 
			clientAccess.readClientSideJson(keys, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}
	
	async saveClientSideJson(session, keys, json) {
		var clientAccess = session.getClientStorageAccessInstance();
		
		const result = new Promise((resolve, reject) => { 
			clientAccess.saveClientSideJson(keys, json, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}

	//
	// Web 3 (ethnode)
	// 
	
	async getNodeInfo(session) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereumnodeaccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		var nodeinfo = {};

		nodeinfo.islistening = global.t('loading');
		nodeinfo.networkid = global.t('loading');
		nodeinfo.peercount = global.t('loading');
		nodeinfo.issyncing = global.t('loading');
		nodeinfo.currentblock = global.t('loading');
		nodeinfo.highestblock = global.t('loading');

		var writenodeinfo = function(nodeinfo, callback) {
			
			ethereumnodeaccess.web3_getNodeInfo(function(err, info) {
				console.log('returning from web3_getNodeInfo');
				
				if (info) {
					nodeinfo.islistening = info.islistening;
					nodeinfo.networkid = info.networkid;
					nodeinfo.peercount = info.peercount;
					nodeinfo.issyncing = info.issyncing;
					nodeinfo.currentblock = info.currentblock;
					nodeinfo.highestblock = info.highestblock;
				}
				else {
					nodeinfo.islistening = global.t('not available');
					nodeinfo.networkid = global.t('not available');
					nodeinfo.peercount = global.t('not available');
					nodeinfo.issyncing = global.t('not available');
					nodeinfo.currentblock = global.t('not available');
					nodeinfo.highestblock = global.t('not available');
				}

				console.log(JSON.stringify(nodeinfo));
				
				if (callback)
					callback(null, nodeinfo);
			})
			.catch(err => {if (callback) callback(err, null);});
		};

		const result = new Promise((resolve, reject) => { 
			writenodeinfo(nodeinfo, (err, res) => {
				if (err) reject(err); else resolve(res);
			});
		});
		
		return result;
	}

	_getNodeInfo(session, callback) {
		// OBSOLETE
		var global = this.global;
		
		var mobileconfigmodule = global.getModuleObject('mobileconfig');
		

		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereumnodeaccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		var nodeinfo = {};

		nodeinfo.islistening = global.t('loading');
		nodeinfo.networkid = global.t('loading');
		nodeinfo.peercount = global.t('loading');
		nodeinfo.issyncing = global.t('loading');
		nodeinfo.currentblock = global.t('loading');
		nodeinfo.highestblock = global.t('loading');

		var writenodeinfo = function(nodeinfo) {
			
			ethereumnodeaccess.web3_getNodeInfo(function(err, info) {
				console.log('returning from web3_getNodeInfo');
				
				if (info) {
					nodeinfo.islistening = info.islistening;
					nodeinfo.networkid = info.networkid;
					nodeinfo.peercount = info.peercount;
					nodeinfo.issyncing = info.issyncing;
					nodeinfo.currentblock = info.currentblock;
					nodeinfo.highestblock = info.highestblock;
				}
				else {
					nodeinfo.islistening = global.t('not available');
					nodeinfo.networkid = global.t('not available');
					nodeinfo.peercount = global.t('not available');
					nodeinfo.issyncing = global.t('not available');
					nodeinfo.currentblock = global.t('not available');
					nodeinfo.highestblock = global.t('not available');
				}

				console.log(JSON.stringify(nodeinfo));
				
				if (callback)
					callback(null, nodeinfo);
			});
		};

		writenodeinfo(nodeinfo);
	}
	
	getWeb3ProviderUrl(session) {
		var global = this.global;

		var ethnodemodule = global.getModuleObject('ethnode');

		return ethnodemodule.getWeb3ProviderUrl(session);
	 }
		
	async setWeb3ProviderUrl(session, providerurl) {
		var global = this.global;

		var ethnodemodule = global.getModuleObject('ethnode');
		
		
		const result = new Promise((resolve, reject) => { 
			// set providerurl as web3 provider
			ethnodemodule.setWeb3ProviderUrl(providerurl, session, (err,res) => {
				if (err) reject(err); else resolve(res);
			}); // does not return a promise
		});
		
		return result;
	}

	async getEthereumNodeAccessInstance(session, web3providerurl) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereumnodeaccessinstance = ethnodemodule.getEthereumNodeAccessInstance(session, web3providerurl);

		return ethereumnodeaccessinstance;
	}
	

	
	_createAccount(session, address, privatekey) {
		var global = this.global;

		var commonmodule = global.getModuleObject('common');
		
		// create account with this address
		var account = commonmodule.createBlankAccountObject(session);
		
		if (privatekey)
			account.setPrivateKey(privatekey);
		else
			account.setAddress(address);
		
		return account;
	}
	
	_getEthAddressBalance(session, address, callback) {
		// OBOSOLETE
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');

		var account = this._createAccount(session, address);
		
		this._getEthAccountBalance(session, account, callback);
	}

	_getEthAccountBalance(session, account, callback) {
		// OBSOLETE
		var global = this.global;

		var ethnodemodule = global.getModuleObject('ethnode');
		var ethnodecontrollers = ethnodemodule.getControllersObject();

		ethnodemodule.getChainAccountBalance(session, account, function(err, res) {
			if (err) {
				if (callback)
					callback(err, null);
			}
			else {
				var etherbalance = (ethnodecontrollers ? ethnodecontrollers.getEtherStringFromWei(res) : null);
				if (callback)
					callback(err, etherbalance);
			}
		});
	}
	


	async getAddressEthBalance(session, address) {
		var global = this.global;
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var ethereumnodeaccess  = ethnodemodule.getEthereumNodeAccessInstance(session);

		var balance = await ethereumnodeaccess.web3_getBalance(address);

		return parseInt(balance);
	}
	
	async getEthAccountTransactionCredits(session, account) {
		var global = this.global;
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var ethereumnodeaccess  = ethnodemodule.getEthereumNodeAccessInstance(session);
		var address = account.getAddress();
		var balance = await ethereumnodeaccess.web3_getBalance(address);

		return parseInt(balance);
	}


	
	async getEthAddressBalance(session, address) {
		var global = this.global;
		
		var account = this.createAccountObject(session, address);
		
		return this.getEthAccountBalance(session, account);
	}


	
	// using accounts
	async getEthAccountBalance(session, account) {
		var global = this.global;

		var ethnodemodule = global.getModuleObject('ethnode');
		var ethnodecontrollers = ethnodemodule.getControllersObject();

		const result = new Promise((resolve, reject) => { 
			ethnodemodule.getChainAccountBalance(session, account, (err, res) => {
				if (err) {
					reject(err);
				}
				else {
					var etherbalance = (ethnodecontrollers ? ethnodecontrollers.getEtherStringFromWei(res) : null);
					resolve(etherbalance);
				}
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
	
	// using accounts
	getEthAccountFromUUID(session, accountuuid, callback) {
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		var commoncontrollers = commonmodule.getControllersObject();
		
		var account = commoncontrollers.getAccountObjectFromUUID(session, accountuuid);
		
		if (callback)
			callback(null, account);
	}
	
	createFee(level) {
		var fee = {};
		
		fee.gaslimit = 4850000 * (feelevel && feelevel.default_gas_limit_multiplier ? parseInt(feelevel.default_gas_limit_multiplier) : 1);
		fee.gasPrice = 	10000000000 * (feelevel && feelevel.default_gas_price_multiplier ? parseInt(feelevel.default_gas_price_multiplier) : 1);
		
		return fee;
	}
	
	createEthereumTransaction(session, fromaccount) {
		var global = this.global;
		
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
	
		var ethereumtransaction =  ethereumnodeaccessmodule.getEthereumTransactionObject(session, fromaccount);
		
		return ethereumtransaction;
	}
	
	createTransaction(session, fromaccount) {
		// OBSOLETE
		var global = this.global;
		
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
	
		var ethereumtransaction =  ethereumnodeaccessmodule.getEthereumTransactionObject(session, fromaccount);
		
		return ethereumtransaction;
	}
	
	sendTransaction(session, transaction, callback) {
		// OBSOLETE
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
		
		var EthereumNodeAccess = ethnodemodule.getEthereumNodeAccessInstance(session);
		
		
		return EthereumNodeAccess.web3_sendEthTransaction(transaction, callback);
	}
	
	getTransaction(session, txhash, callback) {
		// OBSOLETE
		var global = this.global;

		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');

	    ethereumnodeaccessmodule.readEthereumTransactionObject(session, txhash, function(err, res) {
	    	console.log('callback from readEthereumTransactionObject');
	    	
	    	if (err) {
	    		if (callback)
	    			callback(err, null);
	    	}
	    	
	    })
	    .then(function(res) {
	    	console.log('readEthereumTransactionObject finished');
	    	
	    	if (res) {
	    		if (callback)
	    			callback(null, res);
	    	}
	    });
		
	}
	
	async sendEthereumTransaction(session, transaction) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var EthereumNodeAccess = ethnodemodule.getEthereumNodeAccessInstance(session);
		
		const result = new Promise((resolve, reject) => { 
			EthereumNodeAccess.web3_sendEthTransaction(transaction, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
	
	// transactions
	async getEthereumTransactionList(session, bRefresh) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');

		if (bRefresh !== undefined)
		console.log('getTransactionList: refresh parameter is not taken into account');

		const result = new Promise((resolve, reject) => { 
			ethnodemodule.getTransactionList(session, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});

		return result;
	}

	async getEthereumTransactionCount(session, account, defaultBlock) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');
		
		var EthereumNodeAccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		var fromaddress = account.getAddress();
		
		const result = new Promise((resolve, reject) => { 
			EthereumNodeAccess.web3_getTransactionCount(fromaddress, defaultBlock, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
	


	async _getEthNodeTransactionObjectFromHash(session, txhash, callback) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');

		var transactionuuid = session.guid();
		
		var transaction = new ethnodemodule.Transaction(session, transactionuuid);

		transaction.setTransactionHash(txhash);

		if (callback)
			callback(null, transaction);

		return transaction;
	}
	
	async getTransaction(session, txhash) {
		var global = this.global;
		
		var ethnodemodule = global.getModuleObject('ethnode');

		const result = new Promise((resolve, reject) => { 
			//ethnodemodule.getTransactionObjectFromHash(session, txhash, (err, res) => {
			this._getEthNodeTransactionObjectFromHash(session, txhash, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});

		return result;
	}

	async decodedDataToUTF8(session, data) {
		var global = this.global;

		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');

		var data_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(session, data);

		return data_decoded_utf8;
	}
	
	async getEthereumTransaction(session, txhash) {
		var global = this.global;

		var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');

		const result = new Promise((resolve, reject) => { 
			ethereumnodeaccessmodule.readEthereumTransactionObject(session, txhash, (err, res) => {
				if (err) reject(err);
				else {
					var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
					var data = res.data;
					try {
						// can throw invalid UTF8 detected
						res.data_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(session, data);
					}
					catch(e) {}
				
					resolve(res);
				}
			})
			.then(res => {
				// fixing missing callback call when data == null
				// in EthereumNodeAccess.readEthereumTransactionObject
				if (res)
					return res;
				else
					throw new Error('no transaction found with hash ' + txhash);
			})
			.catch(err => {
				reject(err);
			});
		});
		
		return result;

		
	}
	
	async getEthereumTransactionReceipt(session, txhash) {
		var global = this.global;

		var ethnodemodule = global.getModuleObject('ethnode');
		
		var EthereumNodeAccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		const result = new Promise((resolve, reject) => { 
			EthereumNodeAccess.web3_getTransactionReceipt(txhash, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;

		
	}

	async getEthereumContractInstance(session, address, contractpath, ethnodeserverconfig) {
		var global = this.global;

		var web3providerurl = ethnodeserverconfig.web3_provider_url;
		var chainid = ethnodeserverconfig.chainid;
		var networkid = ethnodeserverconfig.networkid;

		var ethnodemodule = global.getModuleObject('ethnode');

		var contractinstance = ethnodemodule.getContractInstance(session, address, contractpath, web3providerurl);
		
		if (chainid)
		contractinstance.setChainId(chainid);
		
		if (networkid)
		contractinstance.setNetworkId(networkid);

		return contractinstance;
	}
	
	//
	// Web 3 (ethchainreader)
	//
	_readCurrentBlockNumber(session, callback) {
		// OBSOLETE
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		chainreaderinterface.getCurrentBlockNumber(callback);
	}
	
	async readCurrentBlockNumber(session) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getCurrentBlockNumber((err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
	
	async readBlock(session, blocknumber) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getBlock(blocknumber, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}

	_readBlock(session, txhash, callback) {
		// OBSOLETE
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		chainreaderinterface.getBlock(blocknumber, callback);
	}
	
	async readTransaction(session, txhash) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getTransaction(txhash,(err, res) => {
				if (err) reject(err); 
				else {
					var ethereumnodeaccessmodule = global.getModuleObject('ethereum-node-access');
					var input = res.input;
					try {
						res.input_decoded_utf8 = ethereumnodeaccessmodule.web3ToUTF8(session, input);
					}
					catch(e) {}
				
					resolve(res);
				}
			})			
			.then(res => {
				// fixing missing callback calls when data == null
				// because of error read property of null in Transaction._createTransactionObject
				if (res)
					return res;
				else
					throw new Error('no transaction found with hash ' + txhash);
			})
			.catch(err => {
				reject(err);
			});
		});
		
		return result;
	}

	_readTransaction(session, txhash, callback) {
		// OBSOLETE
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		chainreaderinterface.getTransaction(txhash, callback);
	}

	async readLatestTransactions(session) {
		var global = this.global;

		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getLatestTransactions((err, res) => {
				if (err) reject(err); else	resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
	
	async readBlockTransactions(session, blocknumber) {
		var global = this.global;

		var ethchainreadermodule = global.getModuleObject('ethchainreader');

		var block = await this.readBlock(session, blocknumber);
		
		const result = new Promise((resolve, reject) => { 
			block.getTransactions((err, res) => {
				if (err) reject(err); else	resolve(res);
			})
			.catch(err => reject(err));			
		});
		
		return result;
	}
	
	async readAccount(session, address) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);

		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getAccount(address,(err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}

	async readContract(session, address, abi) {
		var global = this.global;
		
		var ethchainreadermodule = global.getModuleObject('ethchainreader');
		
		var chainreaderinterface = ethchainreadermodule.getChainReaderInterface(session);

		var contract;
		
		const result = new Promise((resolve, reject) => { 
			chainreaderinterface.getContract(address,(err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		})
		.then(res => {
			contract = res;

			if (abi) {
				contract.setAbi(abi);

				return contract._getInstance();
			}
			else {
				return contract;
			}

		})
		.then(() => {
			return contract;
		});
		
		return result;
	}
	
	
	//
	// Crypto
	//

	async derivePrivateKey(session, passphrase, salt) {
		const pbkdf2 = require('pbkdf2');

		// TODO: we could fetch a passphrase with more entropy via a REST request
		var _passphrase = passphrase.replace(/\s/g, '');
		_passphrase = _passphrase.toUpperCase();

		let iterations = 10000;
		let keylength = 32;
		let digest = 'sha512';

		var _derived_private_key_buff = pbkdf2.pbkdf2Sync(_passphrase, salt, iterations, keylength, digest);
		var _derived_private_key = '0x' + _derived_private_key_buff.toString('hex');

		return _derived_private_key;
	}

	async getCryptoKeyObject(session, privatekey) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setPrivateKey(privatekey);

		return cryptokey;
	}
	
	getPrivateKeyStoreString(session, privkey, passphrase) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setPrivateKey(privkey);
		
		var cryptokeyencryptioninstance = session.getCryptoKeyEncryptionInstance(cryptokey);
		
		return cryptokeyencryptioninstance.getPrivateKeyStoreString(passphrase);
	}
	
	readPrivateKeyFromStoreString(session, keystorestring, passphrase) {
		var cryptokey = session.createBlankCryptoKeyObject();
		var cryptokeyencryptioninstance = session.getCryptoKeyEncryptionInstance(cryptokey);
		
		return cryptokeyencryptioninstance.readPrivateKeyFromStoreString(keystorestring, passphrase);
	}

	generatePrivateKeyFromPassphrase(session, passphrase) {
		var cryptokey = session.createBlankCryptoKeyObject();
		var cryptokeyencryptioninstance = session.getCryptoKeyEncryptionInstance(cryptokey);
		
		return cryptokeyencryptioninstance.generatePrivateKeyFromPassphrase(passphrase);
	}
	
	hash_hmac(session, hashforce, datastring, keystring) {
		var cryptokey = session.createBlankCryptoKeyObject();
		var cryptokeyencryptioninstance = session.getCryptoKeyEncryptionInstance(cryptokey);
	
		return cryptokeyencryptioninstance.hash_hmac(hashforce, datastring, keystring);
	}
	
	
	generatePrivateKey(session) {
		var privkey = session.generatePrivateKey();		
		
		return privkey;
		
	}

	isValidPrivateKey(session, privatekey) {
		try {
			return session.isValidPrivateKey(privatekey);
		}
		catch(e) {
			return false;
		}
	}
	
	isValidAddress(session, address) {
		try {
			return session.isValidAddress(address);
		}
		catch(e) {
			return false;
		}
	}
	
	getPublicKeys(session, privatekey) {
		var account = this.createAccountObject(session, null, privatekey);
		
		var keys = {};
		
		keys['private_key'] = account.getPrivateKey();
		keys['public_key'] = account.getPublicKey();
		keys['address'] = account.getAddress();
		keys['rsa_public_key'] = account.getRsaPublicKey();
		
		return keys;
	}
	
	// symetric
	aesEncryptString(session, privatekey, plaintext) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setPrivateKey(privatekey);

		return cryptokey.aesEncryptString(plaintext);
		
	}
	
	aesDecryptString(session, privatekey, cyphertext) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setPrivateKey(privatekey);

		return cryptokey.aesDecryptString(cyphertext);
	}
	
	signString(session, privatekey, plaintext) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setPrivateKey(privatekey);

		return cryptokey.signString(plaintext);
	}

	validateStringSignature(session, address, plaintext, signature) {
		var cryptokey = session.createBlankCryptoKeyObject();
		cryptokey.setAddress(address);

		return cryptokey.validateStringSignature(plaintext, signature);
	}
	
	// asymetric
	rsaEncryptString(session, senderaccount, recipientaccount, plaintext) {
		return senderaccount.rsaEncryptString(plaintext, recipientaccount)
	}
	
	rsaDecryptString(session, recipientaccount, senderaccount, cyphertext) {
		return recipientaccount.rsaDecryptString(cyphertext, senderaccount)
	}
	
	//
	// Vault
	//
	async getVaultNames(session) {
		var global = this.global;
		var vaulttype = 0;
		
		var commonmodule = global.getModuleObject('common');
		
		const result = new Promise((resolve, reject) => { 
			commonmodule.getVaultList(session, vaulttype, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});

		var names = [];
		var array = await result
		.catch((err) => {
			console.log('no vault in list');
		});
		
		if (!array)
			return names;
		
		for (var i = 0; i < array.length; i++) {
			if (array[i].name)
			names.push(array[i].name);
		}
		
		return names;
	}
	
	getVaultObject(session, vaultname) {
		var global = this.global;
		var vaulttype = 0;
		
		var commonmodule = global.getModuleObject('common');
		
		return commonmodule.getVaultObject(session, vaultname);
	}
	
	async openVault(session, vaultname, passphrase) {
		var global = this.global;
		var vaulttype = 0;
		
		var commonmodule = global.getModuleObject('common');
		
		const result = new Promise((resolve, reject) => { 
			commonmodule.openVault(session, vaultname, passphrase, vaulttype, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});
		
		return result;
	}

	_openVault(session, vaultname, passphrase, type, callback) {
		// OBSOLETE
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		
		commonmodule.openVault(session, vaultname, passphrase, type, callback);
	}

	async createVault(session, vaultname, passphrase) {
		var global = this.global;
		var vaulttype = 0;
		
		var commonmodule = global.getModuleObject('common');
		
		const result = new Promise((resolve, reject) => { 
			commonmodule.createVault(session, vaultname, passphrase, vaulttype, (err, res) => {
				if (err) reject(err); else resolve(res);
			});
		});
		
		return result;
	}
	
	_createVault(session, vaultname, passphrase, type, callback) {
		// OBSOLETE
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		
		commonmodule.createVault(session, vaultname, passphrase, type, callback);
	}
	
	getFromVault(session, vaultname, type, key) {
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		
		return commonmodule.getFromVault(session, vaultname, type, key);
	}

	async putInVault(session, vaultname, key, value) {
		var global = this.global;
		var vaulttype = 0;
		
		var commonmodule = global.getModuleObject('common');
		
		const result = new Promise((resolve, reject) => { 
			commonmodule.putInVault(session, vaultname, vaulttype, key, value, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});
		
		return result;
	}
	
	_putInVault(session, vaultname, type, key, value, callback) {
		// OBSOLETE
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		
		commonmodule.putInVault(session, vaultname, type, key, value, callback);
	}

	async connectVault(session, vaultname, passphrase) {
		const vault = await this.openVault(session, vaultname, passphrase);
		
		if (vault)
			return this.impersonateVault(session, vault);
		else
			return false;
	}

	disconnectVault(session, vault) {
		if (!vault)
			return;
		
		var isvaultidentifier = this.isVaultSessionIdentifier(session, vault);
		
		vault.lock();
		
		if (isvaultidentifier)
		session.disconnectUser();
	}
	
	isVaultSessionIdentifier(session, vault) {
		if (!vault)
			return false;
		
		var sessionuser = session.getSessionUserObject();
		
		if (sessionuser) {
			var vaultname = vault.getName();
			var username = sessionuser.getUserName();
			
			if (username == vaultname) {
				return true;
			}
		}
		
		return false;
		
	}
	
	findVaultIdentifier(session) {
		var vaults = session.getVaultObjects();
		
		if (!vaults)
			return;
		
		for (var i = 0; i < vaults.length; i++) {
			var vault = vaults[i];
			
			if (this.isVaultSessionIdentifier(session, vault))
				return vault;
		}
	}
	
	//
	// Accounts
	//

	async getSessionAccountObjects(session, bRefresh) {
		const result = new Promise((resolve, reject) => { 
			session.getSessionAccountObjects(bRefresh, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});
		
		return result;
	}
	
	async getAccountObjects(session, bRefresh) {
		const result = new Promise((resolve, reject) => { 
			session.getAccountObjects(bRefresh, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});
		
		return result;
	}
	
	async getAccountObjectFromUUID(session, accountuuid) {
		var global = this.global;
		
		var commonmodule = global.getModuleObject('common');
		var commoncontrollers = commonmodule.getControllersObject();
		
		var account = commoncontrollers.getAccountObjectFromUUID(session, accountuuid);
		
		return account;
	}
	
	createBlankAccountObject(session) {
		var global = this.global;

		var commonmodule = global.getModuleObject('common');
		
		return commonmodule.createBlankAccountObject(session);
	}
	
	createAccountObject(session, address, privatekey) {
		var global = this.global;

		var commonmodule = global.getModuleObject('common');
		
		// create account with this address
		var account = commonmodule.createBlankAccountObject(session);
		
		if (privatekey)
			account.setPrivateKey(privatekey);
		else
			account.setAddress(address);
		
		return account;
	}
	
	async saveAccountObject(session, account) {
		var global = this.global;

		var storagemodule = global.getModuleObject('storage-access');
		var storageaccess = storagemodule.getStorageAccessInstance(session);
		
		var sessionuser = session.getSessionUserObject();

		const result = new Promise((resolve, reject) => {
			storageaccess.user_add_account(sessionuser, account, (err, res) => {
				if (err) reject(err); else resolve(res);
			})
			.catch(err => reject(err));
		});
		
		return result;
	}
		
	// static
	static getObject() {
		if (modulecontrollers)
			return modulecontrollers;
		
		modulecontrollers = new ModuleControllers();
		
		return modulecontrollers;
	}
}

module.exports = ModuleControllers; 